import 'css-chunksrc/client/scenes/costProfileEdition/costHistory/cost/numberInput/styles.scss';export default {
  "input": "_input_1abtm_1"
};